import { MediaAlphaExchangeConfig } from './constants/mediaAlphaTypes';

function asBoolean(envvar?: string): boolean | undefined {
  if (envvar === 'true') {
    return true;
  } else if (envvar === 'false') {
    return false;
  } else {
    return undefined;
  }
}

const environment = {
  analyticsLoggingEnabled: asBoolean(import.meta.env.VITE_ANALYTICS_LOGGING_ENABLED),
  dataDogApplicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  dataDogClientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  sentryEnabled: asBoolean(import.meta.env.VITE_SENTRY_ENABLED),
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  dataDogEnabled: asBoolean(import.meta.env.VITE_DATADOG_ENABLED),
  elementsGalleryEnabled: asBoolean(import.meta.env.VITE_ELEMENTS_GALLERY_ENABLED),
  environment: import.meta.env.VITE_ENVIRONMENT,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  mediaAlphaUrl: import.meta.env.VITE_MEDIA_ALPHA_INTEGRATION_SRC,
  mixpanelEnabled: asBoolean(import.meta.env.VITE_MIXPANEL_ENABLED),
  mixpanelToken: import.meta.env.VITE_MIXPANEL_TOKEN,
  releaseSha: import.meta.env.VITE_RELEASE_SHA,
  serverBaseUrl: import.meta.env.VITE_SERVER_BASE_URL,
} as const;

// Warning ChatGPT code
// Here we're declaring that window has an extra property
// __environment which includes the environment variables
// from above
declare global {
  interface Window {
    __environment: typeof environment;
    dataLayer: Record<string, unknown>[];
    MediaAlphaExchange: MediaAlphaExchangeConfig;
    MediaAlphaExchange__load: (elementId: string) => void;
  }
}

if (typeof window !== 'undefined') {
  // we expose __environment on the window for debugging purposes
  // these variables are all public by nature, so there's no risk with exposing them
  window.__environment = environment;
}

export default environment;
